import * as React from 'react';
import { hot } from 'react-hot-loader';
import { Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { login } from 'helpers/asureid';

const AsureIdPage = () => {
  const [isSigningIn, setIsSigningIn] = React.useState(false);
  React.useEffect(() => {
    // Trigger login when component mounts
    const initiateLogin = async () => {
      try {
        setIsSigningIn(true);
        await login();
      } catch (error) {
        localStorage.removeItem('redirectRoute');
        console.error('asureid', error);
        alert('Something went wrong! Check the console for more details');
      } finally {
        setIsSigningIn(false);
      }
    };

    initiateLogin();
  }, []); // Empty dependency array means this runs once on component mount

  return (
    <>
      <Row>
        <Col>
          <h3 className="pt-3">
            <FormattedMessage id="ASURE_ID_REDIRECT" />
          </h3>
          <p className="mt-2">
            {isSigningIn ? (
              <FormattedMessage
                id="SIGNING_IN"
                defaultMessage="Signing in..."
              />
            ) : (
              <FormattedMessage
                id="REDIRECTING_TO_LOGIN"
                defaultMessage="Redirecting to Asure ID login..."
              />
            )}
          </p>
        </Col>
      </Row>
    </>
  );
};

export default hot(module)(AsureIdPage);
